import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";

type YearPickerProps = {
  value: string;
  onChange: (value: string) => void;
  label: string;
  helperText: string;
  minYear: number;
  maxYear: number;
  disabled?: boolean;
};

export const YearPicker = ({
  value,
  onChange,
  label,
  helperText,
  minYear,
  maxYear,
  disabled = false,
}: YearPickerProps) => (
  <DatePicker
    views={["year"]}
    label={label}
    value={value ? dayjs(value) : null}
    onChange={(newValue) => {
      onChange(newValue?.format("YYYY") ?? "");
    }}
    minDate={dayjs().year(minYear)}
    maxDate={dayjs().year(maxYear)}
    disabled={disabled}
    slotProps={{
      textField: {
        fullWidth: true,
        helperText,
        inputProps: {
          readOnly: true,
        },
      },
    }}
  />
);
